import { lazy } from 'react';
import withLoadableComponent from '../withLoadableComponent';
import retry from '../../utils/webpack/chunkRetry';
export default withLoadableComponent(lazy(()=>retry(()=>import(/* webpackChunkName: "noncontentmodals" */ './NonContentModals'))));
